import React, { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllShapes,
  getCurrentShapes,
  getDisplayingShapes,
  selectCurrentPolyonPointIndex,
} from "redux/shape/selector";
import { mapShapeToComponent } from "./mapShapeToComponent";
import { makeCurrTool } from "redux/tools/selectors";
import { selectImageRatio } from "redux/canvas/selectors";
import {
  setCurrentShape,
  setCurrentPolygonPointIndex,
} from "redux/shape/actions";
import * as allTools from "redux/tools/enums";
import { getParameterByName } from "helpers";
import { bool } from "prop-types";
import { selectReporterTab } from "redux/app/selectors";
import {
  getHistoryDisplayingShapes,
  getHistoryShapes,
} from "redux/labelingHistory/selector";

function ShapeLayer({ permissionEdit = false }) {
  const dispatch = useDispatch();
  const currTool = useSelector(makeCurrTool);
  const currentShape = useSelector(getCurrentShapes);
  const ratio = useSelector(selectImageRatio);
  const currentPolygonPoint = useSelector(selectCurrentPolyonPointIndex);

  const reporterTab = useSelector(selectReporterTab);
  const mainShapes = useSelector(getAllShapes);
  const mainDisplayingShapes = useSelector(getDisplayingShapes);
  const hisShapes = useSelector(getHistoryShapes);
  const hisDisplayingShapes = useSelector(getHistoryDisplayingShapes);

  const shapes = useMemo(
    () => (reporterTab === "history" ? hisShapes : mainShapes),
    [reporterTab, mainShapes, hisShapes]
  );
  const displayingShapes = useMemo(
    () =>
      reporterTab === "history" ? hisDisplayingShapes : mainDisplayingShapes,
    [reporterTab, mainDisplayingShapes, hisDisplayingShapes]
  );

  useEffect(() => {
    if (currentPolygonPoint) dispatch(setCurrentPolygonPointIndex(-1));
  }, [currentShape]);

  const alterUserId = getParameterByName("alterUserId");
  const isViewResult = getParameterByName("isViewResult");

  const handleSelectShape = (item) => () => {
    if (currTool || alterUserId || isViewResult) return;
    if (item.id !== currentShape?.id) dispatch(setCurrentShape(item));
  };

  const handleChangeCurrentPolygonPoint = (index) => {
    dispatch(setCurrentPolygonPointIndex(index));
  };

  return (
    <>
      {shapes.map((item) => {
        const Component = mapShapeToComponent[item.classesTypeCode];
        if (!Component) return null;
        if (
          displayingShapes.findIndex(
            (shape) => item.id === shape.id && item.labelId === shape.labelId
          ) !== -1
        ) {
          const polygonExtraProps = [
            `${allTools.POLYGON_MODE}-image`,
            `${allTools.POLYLINE_MODE}-image`,
          ].includes(item.classesTypeCode)
            ? {
                currentPoint: currentPolygonPoint,
                onChangeCurrentPoint: handleChangeCurrentPolygonPoint,
              }
            : {};

          return (
            <Component
              key={item.id}
              ratio={ratio}
              isSelected={currentShape?.id === item.id}
              onSelect={handleSelectShape(item)}
              properties={item}
              draggable={permissionEdit && currentShape?.id === item.id}
              permissionEdit={permissionEdit}
              {...polygonExtraProps}
            />
          );
        }
      })}
    </>
  );
}

ShapeLayer.propTypes = {
  permissionEdit: bool,
};

export default memo(ShapeLayer);
